import { StatelessComponent } from 'react'
import * as styles from 'styles/atoms/ChartTooltip.css'

type ChartTooltipProps = {
  color: string
}

const ChartTooltip: StatelessComponent<ChartTooltipProps> = ({ children, color }) => (
  <div
    className={ styles.chartTooltip }
    style={{ backgroundColor: color }}
  >
    { children }
    <div
      className={ styles.arrow }
      style={{ borderColor: `${ color } transparent transparent transparent` }}
    />
  </div>
)

export default ChartTooltip
